const oidcConfig = {
    authority: "https://main.aws-keycloak.datumsolutions.me/auth/realms/service-registry",
    client_id: "service-registry",
    redirect_uri: window.location.href,
    post_logout_redirect_uri: window.location.protocol + '//' + window.location.host
};

export default oidcConfig